import axios from 'axios';
import '../config.js';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    Authorization: `Bearer ${token}`,
  };
};

const buildQuery = (appProviderId) => {
  if (appProviderId === null || appProviderId === undefined || appProviderId === '') {
    return '';
  }

  return `?appProviderId=${encodeURIComponent(String(appProviderId))}`;
};

const buildPath = (customerId, locationId, appProviderId) => {
  return `${global.config.url}/support/tiletimelimitation/${customerId}/locations/${locationId}${buildQuery(appProviderId)}`;
};

export const getTileTimeLimitation = async (customerId, locationId, appProviderId) => {
  const response = await axios.get(buildPath(customerId, locationId, appProviderId), {
    headers: authHeaders(),
  });

  return response.data;
};

export const saveTileTimeLimitation = async (customerId, locationId, payload, appProviderId) => {
  const response = await axios.put(buildPath(customerId, locationId, appProviderId), payload, {
    headers: {
      ...authHeaders(),
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });

  return response.data;
};

const tileTimeLimitationApi = {
  getTileTimeLimitation,
  saveTileTimeLimitation,
};

export default tileTimeLimitationApi;